<template>
  <o-dialog
    ref="dialog"
    :title="$t('order.close')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.order.actions.closeOrder.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="pt-4 text-left text-sm">
      <checkbox-field v-model="sendEmail" :label="$t('components.order.actions.closeOrder.sendEmail')" :info="$t('components.order.actions.closeOrder.sendEmailInfo')" />
      <checkbox-field v-model="print" :label="$t('general.print')" :info="$t('components.order.actions.closeOrder.printInfo')" />
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import {
  CheckboxField,
} from '@/components/fields'

interface Props {
  order: Record<string, any>
  portal?: string | null
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<{
  'update:order': [value: any]
  'update:loading': [value: boolean]
  'success': [value: boolean]
}>()

const { $api, $notification, $bus, $auth, $i18n } = useNuxtApp()

const dialog = ref<any>(null)

const sendEmail = ref(true)
const print = ref(false)

const info = computed(() => {
  return $i18n.t('components.order.actions.closeOrder.info', { number: props.order.orderNumber })
})

function open() {
  dialog.value.open()

  sendEmail.value = $auth.info?.location?.sendInternalOrderCloseNotifications
}

async function confirm() {
  const sendEmailVal = sendEmail.value

  try {
    const response = await $api.order.close(String(props.order.idOrder), { sendEmail: sendEmailVal })
    const order = response.data
    $bus.emit.updated('Order', order)

    if (order) {
      emit('update:order', order)
      emit('update:loading', false)
      emit('success', print.value)

      $notification.toast({
        title: $i18n.t('components.order.actions.closeOrder.success'),
        text: $i18n.t('components.order.actions.closeOrder.successInfo', { number: props.order.orderNumber }),
      })

      return true
    }
  } catch (e) {
    console.log(e)
  }
}

defineExpose({ open })
</script>
